import { AuthCopy } from './auth-copy.model';

export const AUTH_COPY: AuthCopy = {
  externalPasswordResetAvailable: true,
  externalPasswordResetUrl: 'https://passwordreset.microsoftonline.com/',
  externalPasswordResetDescription:
    "Use Microsoft's self-service password reset for your work account.",
  externalPasswordResetLabel: 'Reset your Microsoft password',
  externalPasswordResetAriaLabel: 'Reset your Microsoft password (opens in new tab)',
  signInLabel: 'Sign in with Microsoft',
  redirectingLabel: 'Redirecting...',
  sessionExpiredMessage: 'Your Microsoft sign-in session expired. Please try again.',
  signInFailedMessage: "We couldn't complete Microsoft sign-in. Please try again.",
  accessDeniedMessage:
    'Microsoft sign-in was cancelled before it finished. Choose "Sign in with Microsoft" to try again.',
  providerErrorMessage:
    'Microsoft reported a problem while signing you in. Please try again in a moment.',
  providerUnreachableMessage:
    "We couldn't reach Microsoft to finish signing you in. This is usually temporary; please try again in a minute.",
  providerRejectedMessage:
    'Microsoft did not accept this sign-in attempt. Please start again from this page rather than an old link.',
  wrongTenantMessage:
    "That Microsoft account isn't part of Dingley's Promise. Sign in with your Dingley work account.",
  noAccessMessage:
    "You signed in, but this account hasn't been given access to the Assessment Platform yet. Ask your site manager to add your work email.",
  accountInactiveMessage:
    'This account has been deactivated on the Assessment Platform. Contact your site manager if you think that is wrong.',
  identityConflictMessage:
    "This email is already linked to a different Microsoft account. Contact Dingley's Promise support so we can sort it out.",
  passwordManagedMessage: 'Password changes are managed by Microsoft for this account.',
};
